import ApiHandler from "./ApiHandler";

const Message = {
  postOne: async (data, options) => await ApiHandler.i.auth().post('/message', data, options),
};

export default Message;